import { alpha, styled, Switch } from '@mui/material'

export const SwitchDefault = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: '#A69478',
        '&:hover': {
            backgroundColor: alpha('#A69478', theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#A69478',
    },
}))
